module.exports = __webpack_public_path__ + "media/thumbnails/face-style-1-20670b16.svg";